import { render, staticRenderFns } from "./PermList.vue?vue&type=template&id=6c0f1ced&"
import script from "./PermList.vue?vue&type=script&lang=js&"
export * from "./PermList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports